export const blockNames = [
    'TEXT_BLOCK' as const,
    'THINKING_BLOCK' as const,
    'TOOL_USE_BLOCK' as const,
    'TOOL_RESULT_BLOCK' as const,
    'METADATA' as const,
    'TOOL_PROCESSING' as const,
]
export type BlockNames = typeof blockNames[0]
